import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogActions } from '@angular/material/dialog';


@Component({
  selector: 'app-inception-date-dialog',
  standalone: true,
  imports: [MatDialogActions],
  templateUrl: './inception-date-dialog.component.html',
  styleUrl: './inception-date-dialog.component.scss'
})
export class InceptionDateDialogComponent {
constructor(private dialogRef: MatDialogRef<InceptionDateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  onSuccessResponse() {
    this.dialogRef.close(true);     
  }

  onNegativeResponse() {
    this.dialogRef.close();
  }
}
